import { ClientsService } from './../../../shared/services/clients.service';
import { SitesService } from './../../../shared/services/sites.service';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { Client } from '@classes/client';
import { ProductTypesService } from '@services/productTypes.service';
import { ProductType } from '@classes/productType';

@Component({
  selector: 'app-product-type-edit',
  templateUrl: './product-type-edit.component.html',
  styleUrls: ['./product-type-edit.component.scss']
})
export class ProductTypeEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() productType: ProductType;
  clients: Client[];

  stringMaxLength = 50;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private clientsSrv: ClientsService,
    private productTypesSrv: ProductTypesService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;
    this.clientsSrv.getList().subscribe(clientsFromSrv => {
      this.clients = clientsFromSrv;
      this.isLoading = false;
      this.initForm();
    });
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.productType) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const productTypeCopy: ProductType = JSON.parse(JSON.stringify(this.productType));
    productTypeCopy.name = this.editForm.value.name;
    productTypeCopy.client = this.editForm.value.client;
    productTypeCopy.minimum = this.editForm.value.minimum;
    productTypeCopy.maximum = this.editForm.value.maximum;

    this.productTypesSrv.put(productTypeCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.productType = new ProductType(
      this.editForm.value.name,
      this.editForm.value.client,
      this.editForm.value.minimum,
      this.editForm.value.maximum,
    );

    this.productTypesSrv.post(this.productType)
      .subscribe(
        () => this.isLoading = false,
        () => this.productType = null
      );
  }

  private initForm(): void {
    let name = "";
    let client = null;
    let minimum = null;
    let maximum = null;

    if (this.productType) {
      name = this.productType.name;
      client = this.productType.client || null;
      minimum = this.productType.minimum;
      maximum = this.productType.maximum;
    }

    this.editForm = this.fb.group({
      name: [name, [Validators.required, Validators.maxLength(this.stringMaxLength)]],
      client: [client, Validators.required],
      minimum: [minimum, Validators.required],
      maximum: [maximum, Validators.required]
    });
  }
}
